export enum ApiEndpoints {
    //Authentiations
    LOGIN = "/api/login",
    LOGOUT = "/api/logout",
    CREATE_CAPTCHA_CODE = "/api/captcha/generate",
    CHECK_SESSION = "/api/session",
    REFRESH_SESSION = "/api/session/refresh",
    GET_VERSIONS = '/api/get-app-version',
    UPLOAD_NEW_APK = 'api/upload-new-apk',

    GET_SPECIAL_GROUPS = '/api/getSpecialGroup',
    //Dashboard
    GET_DASHBOARD_SUMMARY = "/api/dashboard/summary",
    GET_TRANSACTION_BY_CLASS = "/api/chart/transaction/classes",

    USER = '/api/users',
    CARD = '/api/cards',
    GET_PRE_POST_OPERATOR_ITEM = '/api/get/pre/post/operator/collections',
    GET_PRE_POST_OPERATOR_TNX = '/api/get/pre/post/operator/train/transactions',
    POST_OPERATOR_TRANSACTIONS = '/api/post/operator/collections',
    OPERATOR_COLLECTIONS = '/api/operator-collections',
    OPERATOR_STATUS = '/api/operator/get-status',
    login = '/api/login',
    check_2fa = '/api/check-2fa',
    resend_otp = '/api/resend-2fa',
    verify_authenticator = '/api/verify-authenticator',
    setup_authenticator = '/api/setup-authenticator',
    confirm_authenticator = '/api/confirm-authenticator',
    disable_authenticator = '/api/disable-authenticator',
    user = '/api/users',
    cards = '/api/cards',
    card_details = '/api/card_details',
    card_customer_details = '/api/card_customer_details',
    UPDATE_CARD_DETAILS = '/api/update-card-details',
    update_customer = '/api/update_customer',
    update_account = '/api/update_account',
    DOWNLOAD_CARD_TEMPLATE = '/api/download-card-template',
    //customers api
    customers = '/api/customers',
    customer_details = '/api/customer_details',
    customer_accounts_details = '/api/customer_accounts_details',
    customer_accounts = '/api/customer_accounts',
    blocked_accounts = '/api/blocked_accounts',
    contract_institutions = '/api/contract_institutions',
    account_packages = '/api/account_packages',
    employee_incentives = '/api/employee_incentives',
    employee_incentives_details = '/api/employee_incentives_details',
    ACCOUNT_USAGES = '/api/account_usages',

    //devices api
    devices = '/api/devices',
    device_details = '/api/device_details',
    device_generate_code = '/api/device_generate_code',
    update_device = '/api/update_device',
    update_train = '/api/update_train',
    device_operators = '/api/device_operators',
    device_operator_details = '/api/device_operator_details',
    activate_device_operator = '/api/operator/activate',
    device_operators_api = '/api/device_operators_api',
    DEVICE_OPERATOR_WITHOUT_WAGON = '/api/device/operator/without/wagon',
    operator_allocations = '/api/operator_allocations',
    train_details_informations = '/api/train_details_informations',
    TRAINS_WITH_WAGONS = '/api/trains-with-wagons',
    TRAINS = '/api/trains',
    // managements api
    train_lines = '/api/train_lines',
    TRAIN_PAGINATE = '/api/train/paginated',
    train_details = '/api/train_details',
    train_detail = '/api/train_detail',
    train_classes = '/api/train_classes',
    train_routes = '/api/train_routes',
    train_routes_api = '/api/train_routes_api',
    train_register = '/api/train_register',
    train_stations = '/api/train_stations',
    train_get_all_stations = '/api/get_train_stations',
    stations = '/api/get/stations',
    stations_main = '/api/get/stations-main',
    train_prices = '/api/train_prices',
    train_schedules = '/api/train_schedules',
    cfm_regions = '/api/cfm_regions',
    train_directions = '/api/train_directions',
    fare_price_categories = '/api/fare_price_categories',
    genders = '/api/genders',
    zone_prices = '/api/zone_prices',
    automotora_price = '/api/automotora_price',
    update_automotora_price = '/api/update_automotora_price',
    normal_price = '/api/normal_price',

    normal_price_filter_options = '/api/normal_price/filter-options',
    import_normal_price = '/api/normal_price/import-excel',
    import_normal_price_template = '/api/normal_price/import-template',
    import_normal_price_status = '/api/normal_price/import-status',
    // Train Penalty Routes
    train_penalties = '/api/train-penalties',
    train_penalty_filter_options = '/api/train-penalties/filter-options',
    train_penalty_show = '/api/train-penalties',
    train_penalty_update = '/api/train-penalties',
    train_penalty_bulk_update = '/api/train-penalties/bulk-update',

    penaltys_price = '/api/penaltys_price',


    add_zones_price = '/api/add_zones_price',
    add_automotora_price = '/api/add_automotora_price',
    add_normal_price = '/api/add_normal_price',
    zones = '/api/zones',
    add_zones = '/api/add_zones',
    zones_list = '/api/zones_list',
    group_list = '/api/group_list',
    device_types = '/api/device_types',
    on_off_tickets = '/api/on_off_tickets',
    operator_types = '/api/operator_types',
    provinces = '/api/provinces',
    transaction_details = '/api/transaction_details',
    suspicious_transaction_details = '/api/suspicious_transaction_details',
    transaction_topup_details = '/api/transaction_topup_details',

    //TRANSACTIONS
    EXTENDED_TRANSACTION_TYPES = '/api/extended-transaction-types',
    TRAINS_FOR_REPORTS = '/api/report-get-train-list',
    TRANSACTION_SOURCES = '/api/transaction-sources',
    TRANSACTION_STATUSES = '/api/transaction-statuses',
    TRAIN_TYPES = '/api/train-types',
    CFM_CLASSES = '/api/cfm-classes',
    train_station_schedule_times = '/api/train_station_schedule_times',
    operator_category = '/api/operator_category',


    //Cargo Customers
    CARGO_CUSTOMER = '/api/cargo-customers',
    // CARGO_CUSTOMER_DETAIL = '/api/cargo-customer-details',
    CARGO_TRANSACTION = '/api/cargo-transactions',
    CARGO_CUSTOMER_CHANGE_STATUS = '/api/cargo-customers/change/status',
    CARGO_CUSTOMER_TYPE = '/api/cargo-customer-types',
    CARGO_CUSTOMER_SERVICE_TYPE = '/api/cargo-customer-service-types',
    CARGO_CUSTOMER_PAY_TYPE = '/api/cargo-customer-pay-types',
    CARGO_CATEGORIES = '/api/cargo-categories',
    DEFAULT_CARGO_CATEGORIES = '/api/default/cargo-categories',
    CARGO_SUB_CATEGORIES = '/api/cargo-sub-categories',
    CARGO_TRACKING_STATUSES = '/api/cargo-tracking-statuses',
    ALL_CARGO_TRACKING_STATUSES = '/api/all/tracking/statuses',
    CARGO_PRICES = '/api/cargo-prices',
    GET_PACKAGES_WITH_FEW_DETAILS = '/api/get-packages-with-few-details',
    GET_PACKAGES_ALL = '/api/get-packages-all',

    //Reports
    REPORT_REQUESTS = '/api/report-requests',
    REPORT_LAST_REQUESTS = '/api/last/report-request',
    MODULE_REPORTS = '/api/module-reports',
    GET_FILE = '/api/get-file',
    REPORTS = '/api/reports',
    REPORT_PARAMETERS = '/api/report-parameters',
    VIEW_REPORT_FILE = '/api/get/report/file',
    TRANSACTION_SUMMARY_OPTIONS = '/api/transaction-summary-options',

    //Manage Users
    manage_users = '/api/users',
    activate_user = '/api/users/activate',
    MANAGE_ROLES = '/api/roles',
    permissions = '/api/permissions',
    SYSTEM_MODULE_ACTIONS = '/api/system-module-actions',
    ROLE_WITH_ACTIONS = '/api/role-with-actions',
    UPDATE_ROLE_ACTION = '/api/role-with-actions/update',
    ROLE_DETAILS = '/api/role/details',
    RESET_PASSWORD = '/api/users/reset/password',
    OPERATOR_RESET_PASSWORD = '/api/operators/reset-password',
    DELETE_TRAIN = '/api/trains/delete-train',
    DELETE_STATION = '/api/delete-station',
    DELETE_WAGON = '/api/delete-wagon',
    DELETE_TRAIN_LAYOUT = '/api/delete-train-layout',

    //Manage trains
    DEFINE_CABIN = '/api/cabins',
    WAGONS = '/api/wagons',
    WAGONS_WITHOUT_PAGINATION = '/api/all/wagons',
    ASSIGN_WAGON = '/api/wagon-setups',
    ASSIGN_CABIN = '/api/cabin-setups',
    SPECIAL_GROUP = '/api/special-groups',
    TRAIN_WITHOUT_LAYOUT = 'api/trains/without/layout',
    TRAIN_LAYOUTS = 'api/train-layouts',
    ALL_TRAIN_LAYOUTS = 'api/all/train-layouts',

    //Wagon
    WAGON_MANUFACTURES = '/api/wagon-manufactures',
    WAGON_LAYOUT = '/api/wagon-layouts',
    SEATS_FROM_WAGON_LAYOUT = '/api/seats-wagon-layouts',
    GENERATE_LAYOUT_SEATS = '/api/generate-seats',
    SEAT_TYPES = '/api/seat-types',
    NEWS_AND_UPDATES = '/api/news-updates',
    INFORMATION = '/api/information',

    //Train Schedule
    TRAIN_SCHEDULES = '/api/train-schedules',
    TODAY_TRAINS = '/api/today-trains',
    ALL_TRAIN_SCHEDULES = '/api/all/train-schedules',

    //Stations
    ALL_STATIONS_FOR_REPORT = '/api/get/all/trains/for/reports',

    //Audit Trails
    AUDIT_TRAILS = '/api/audit-trails',
    DEVICE_SUMMARY = '/api/device-summary',

    //Operator Incentive
    OPERATOR_INCENTIVE_CONFIGURATIONS = '/api/operator/incentive/configurations',

    //Approval Process
    APPROVAL_PROCESSES_BY_CODE = '/api/approval-process-by-code',
    APPROVAL_PROCESS_DETAILS = '/api/approval-process-details',
    APPROVAL_PROCESS_SUBMIT = '/api/approval-process',


    //operator
    OPERATORS = '/api/operators',
    OPERATOR_ACCOUNTS = '/api/operator-accounts',
    OPERATOR_ACCOUNT_DETAIL = '/api/operator-account-details',

    IDENTIFICATION_TYPES = '/api/identification-types',


    TICKET_TRANSACTIONS = '/api/ticket-transactions',
    TRANSACTION_DETAILS = '/api/transaction-details',
    VALIDATION_DETAILS = '/api/transactions/validation',
    TRAIN_CAPASITY = '/api/transactions/train-capacity',
    REQUEST_CANCEL_TICKET_TRANSACTION = '/api/request/cancel/ticket/transaction',
    REQUEST_CANCEL__MULTIPLE_TICKET_TRANSACTION = '/api/request/cancel/multiple/ticket/transaction',
    CANCEL_TICKET_TRANSACTION = '/api/cancel/ticket/transaction',
    CHANGE_PASSWORD = '/api/change-password',
    VALIDATION_STATUSES = '/api/validation-statuses',
    CARD_STATEMENT = '/api/card-statement',
    OPERATOR_SUMMARY_DETAILS = '/api/operator/summary/details',
    GET_CUSTOMER_ACCOUNTS = '/api/get/customer_accounts',
    GET_INACTIVE_CARDS = '/api/get/inactive/cards',
    CARD_BALANCE_ADJUSTMENT_REQUEST = '/api/card-balance-adjustment',
    CANCEL_TNX_APPROVAL_PROCESSES = '/api/cancel-transaction-approvals',
    ASSIGN_CARD_TO_CUSTOMER = '/api/assign/card/to/customer',
    RESET_CUSTOMER_PIN = '/api/reset/customer/pin',


    M10_SUMMARY = '/api/m10-summary',
    USER_PROFILE = 'user/profile',
    UPDATE_LOCALE = 'api/user/locale',
    UPDATE_NORMAL_PRICE = 'api/normal_prices/update_normal_price',

    NEW_REGISTRATIONS = '/api/new-registrations',
    CUSTOMER_FILE = '/api/customer/file',

    // PHC Sync
    PHC_TICKET_TRANSACTIONS = '/api/phc/ticket-transactions',
    PHC_TOPUP_TRANSACTIONS  = '/api/phc/topup-transactions',
    PHC_CARD_TRANSACTIONS   = '/api/phc/card-transactions',
    PHC_CARGO_TRANSACTIONS  = '/api/phc/cargo-transactions',

}

